import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_SESSION_TYPES, 
    ADD_NEW_SESSION_TYPE, 
    UPDATE_SESSION_TYPE, 
    DELETE_SESSION_TYPE 
} from "./actionTypes";

import {
    getSessionTypesSuccess,
    getSessionTypesFail,
    addSessionTypeSuccess,
    addSessionTypeFail,
    updateSessionTypeSuccess,
    updateSessionTypeFail,
    deleteSessionTypeSuccess,
    deleteSessionTypeFail,
   
} from "./actions"

import {
    getSessionTypes,
    addNewSessionType,
    updateSessionType,
    deleteSessionType,
   
} from "helpers/session-types/session_types_backend_helper";
import { toast } from "react-toastify";

function* fetchSessionTypes() {
    try {
        const response = yield call(getSessionTypes)

        console.log("FEE TYPES: ", response);
        yield put(getSessionTypesSuccess(response))
    } catch (error) {
        yield put(getSessionTypesFail(error))
    }
}

function* onAddNewSessionType({ payload }) {
    try {

        
        const response = yield call(addNewSessionType, payload)

        console.log("RESPONSE:", response);
        yield put(addSessionTypeSuccess(response.sessionType))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addSessionTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateSessionType({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateSessionType, payload)
        yield put(updateSessionTypeSuccess(response.sessionType))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateSessionTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteSessionType({ payload: data }) {

    try {
        const response = yield call(deleteSessionType, data)
        yield put(deleteSessionTypeSuccess(response.sessionTypeId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteSessionTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* sessionTypeSaga() {
    yield takeEvery(GET_SESSION_TYPES, fetchSessionTypes)
    yield takeEvery(ADD_NEW_SESSION_TYPE, onAddNewSessionType)
    yield takeEvery(UPDATE_SESSION_TYPE, onUpdateSessionType)
    yield takeEvery(DELETE_SESSION_TYPE, onDeleteSessionType)
}

export default sessionTypeSaga;